import React, { ReactNode, useEffect } from 'react';
import { useSnackbar } from 'notistack';

export function BaseAlert({ children }: {children: ReactNode | ReactNode[]}) {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    enqueueSnackbar(children || 'Oops! an error occurred', {
      variant: 'error'
    });
  }, [children, enqueueSnackbar]);

  return null;
}
